import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-recipient-modal-form.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-recipient-modal-form.component.scss?ngResource";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as RecipientFormConstants from "../../recipient-select/recipient-select.constants";
import { SharedConstants } from "../../../constants/shared.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertType } from "../../../models/alert";
import { AppControllerService } from "../../../../app-controller.service";
import { RecipientSelectService } from "../../recipient-select/shared/service/recipient-select.service";
import { AppConfig } from "../../../../app.config";
let EditRecipientModalFormComponent = class EditRecipientModalFormComponent {
    activeModal;
    changeDetectorRef;
    recipientSelectService;
    appController;
    title;
    groupsFromMetaData;
    recipientToEdit;
    showRecipientsGroupsDropdown = true;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    dialogTitle;
    editRecipientForm;
    cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    defaultAddRecipientRecipient = RecipientFormConstants.ADD_DEFAULT_RECIPIENT_LABEL;
    recipient;
    formControlName = RecipientFormConstants.FORM_CONTROL_NAME;
    constructor(activeModal, changeDetectorRef, recipientSelectService, appController) {
        this.activeModal = activeModal;
        this.changeDetectorRef = changeDetectorRef;
        this.recipientSelectService = recipientSelectService;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initializeForm();
        this.setConfigurableDialogTitle();
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    onBtnSaveClicked() {
        if (this.editRecipientForm.valid) {
            const newRecipient = this.editRecipientForm.get(this.formControlName).value;
            delete newRecipient.groupsStringArray;
            this.activeModal.close(newRecipient);
        }
        else {
            this.recipientSelectService.markFormControlAsTouched.emit(true);
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    ngAfterViewInit() {
        const applicantAgentRecipientFormControl = this.editRecipientForm.get("recipientFormControl");
        this.recipientSelectService.setRecipient(this.recipient, true, applicantAgentRecipientFormControl);
        this.editRecipientForm.get("recipientFormControl").setValue(this.recipient);
        this.changeDetectorRef.detectChanges();
    }
    initializeForm() {
        this.editRecipientForm = new FormGroup({
            recipientFormControl: new FormControl(null, Validators.required)
        });
        const recipientGroupsStringArray = this.recipientToEdit.groups.map(r => r.groupName);
        this.recipientToEdit.groupsStringArray = recipientGroupsStringArray;
        this.recipient = this.recipientToEdit;
        this.changeDetectorRef.detectChanges();
    }
    setConfigurableDialogTitle() {
        if (this.title !== undefined || this.title != null || this.title !== "") {
            this.dialogTitle = `Edit ${this.title}`[0].toUpperCase() + `Edit ${this.title}`.substr(1).toLowerCase();
        }
        else {
            this.dialogTitle = this.defaultAddRecipientRecipient;
        }
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: ChangeDetectorRef },
        { type: RecipientSelectService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        title: [{ type: Input }],
        groupsFromMetaData: [{ type: Input }],
        recipientToEdit: [{ type: Input }],
        showRecipientsGroupsDropdown: [{ type: Input }]
    };
};
EditRecipientModalFormComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-edit-recipient-modal-form",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], EditRecipientModalFormComponent);
export { EditRecipientModalFormComponent };
